import "./i18n/i18n";
import { useEffect } from "react";
import { SnackbarProvider, closeSnackbar } from "notistack";
import CloseIcon from "@mui/icons-material/Close";

import { UserContextProvider } from "components/helper/userContext";
import { SessionContextProvider } from "components/helper/sessionContext";
import { TokenContextProvider } from "components/helper/tokenContext";

import Router from "./Router";
import GlobalStylesWrapper from "components/GlobalStylesWrapper";
import { SubdomainProvider } from "components/helper/SubdomainContext";

function App() {
    // Escape dismisses the toasts, so they never hide the focused element (WCAG 2.4.11).
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === "Escape") {
                closeSnackbar();
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, []);

    return (
        <div>
            <SessionContextProvider>
                <SnackbarProvider
                    maxSnack={1}
                    autoHideDuration={3000}
                    transitionDuration={{ enter: 120, exit: 150 }}
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "center",
                    }}
                    style={{
                        backgroundColor: "rgba(211,71,66,0.90)",
                        color: "#000",
                    }}
                    hideIconVariant={true}
                    action={(snackbarId) => (
                        <div onClick={() => closeSnackbar(snackbarId)}>
                            <CloseIcon
                                style={{
                                    position: "absolute",
                                    top: "3px",
                                    right: "3px",
                                    fontSize: "17px",
                                    color: "#000",
                                    cursor: "pointer",
                                }}
                            />
                        </div>
                    )}
                >
                    <UserContextProvider>
                        <TokenContextProvider>
                            <GlobalStylesWrapper />
                            <SubdomainProvider>
                                <Router />
                            </SubdomainProvider>
                        </TokenContextProvider>
                    </UserContextProvider>
                </SnackbarProvider>
            </SessionContextProvider>
        </div>
    );
}

export default App;
